/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceRequest } from '../../models/invoice-request';
import { InvoiceRequestApiRespModel } from '../../models/invoice-request-api-resp-model';

export interface ApiRequestInvoiceSaveSubmitPost$Params {
      body?: InvoiceRequest
}

export function apiRequestInvoiceSaveSubmitPost(http: HttpClient, rootUrl: string, params?: ApiRequestInvoiceSaveSubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceRequestApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiRequestInvoiceSaveSubmitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceRequestApiRespModel>;
    })
  );
}

apiRequestInvoiceSaveSubmitPost.PATH = '/api/Request/Invoice/SaveSubmit';
